var SettingsTitleEnum = {
  customerSupport: 'CONTACT SUPPORT',
  messageSent: 'MESSAGE SENT',
  messageSentError: 'MESSAGE SENT ERROR',
  account: 'ACCOUNT',
  changePassword: 'CHANGE PASSWORD',
  changePasswordSuccess: 'UPDATE SUCCESSFUL',
  changePasswordError: 'UPDATE ERROR',
  updateEmail: 'UPDATE EMAIL',
  updateEmailSuccess: 'UPDATE SUCCESSFUL',
  updateEmailError: 'UPDATE ERROR',
  termsAndConditions: 'TERMS AND CONDITIONS',
  privacyPolicy: 'PRIVACY POLICY',
  settings: 'SETTINGS'
};
export default SettingsTitleEnum;